import AgentsIndex from '@/views/AgentsIndex.vue';
import AgentsCreate from '@/views/AgentsCreate.vue';
import AgentsEdit from '@/views/AgentsEdit.vue';

const routes = [
    {
        path: '/agents',
        name: 'AgentsIndex',
        component: AgentsIndex,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/agents/create',
        name: 'AgentsCreate',
        component: AgentsCreate,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/agents/:id',
        name: 'AgentsEdit',
        component: AgentsEdit,
        meta: { layout: 'DashboardLayout' }
    }
];

export default routes
